import { HttpClient } from '@angular/common/http';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RsaService } from './rsa.service';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  private _refreshNeeded$ = new Subject<void>();

  public baseUrl = environment.apiBaseUrl + '/users';
  public userName = '';
  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  selectValuesChanged = new EventEmitter();
  subsVar: Subscription;


  public screenWidth: any;
  public collapseSidebar = false;

  public selectValues = [];
  public filteredSelection = [];
  public uniqueSelectValues = [];

  public partyList = [];
  public uniquePartyList = [];
  public partySelected = '';
  public partyNameSelected = '';
  public partyId = '';
  public select1 = 'All';
  public select2 = 'All';
  public select3 = 'All';
  public select1Id = 'All';
  public select2Id = 'All';
  public select3Id = 'All';
  constructor(private rsaService: RsaService, private http: HttpClient, public router: Router) {
  }

  setSelectValues(data, count) {
    this.selectValues = data;
    this.filteredSelection = JSON.parse(JSON.stringify(data));
    this.select1 = 'All';
    this.select2 = 'All';
    this.select3 = 'All';
    this.select1Id = 'All';
    this.select2Id = 'All';
    this.select3Id = 'All';
    // if (this.filteredSelection.length === 1) {
    //   this.select1 = this.filteredSelection[0].SELLER_BUSINESS_UNIT;
    //   this.select1Id = this.filteredSelection[0].ORG_ID;
    //   this.select2 = this.filteredSelection[0].ACCOUNT_NAME;
    //   this.select2Id = this.filteredSelection[0].CUST_ACCOUNT_ID;
    //   this.select3 = this.filteredSelection[0].CUSTOMER_SITE;
    //   this.select3Id = this.filteredSelection[0].CUST_ACCT_SITE_ID;
    // }
    if (count > 0) {
      this.getAllPartyList({
        email: this.rsaService.decrypt(localStorage.getItem('3')),
      });
      this.partySelected = this.filteredSelection[0].PARTY_ID;
      this.partyNameSelected = this.filteredSelection[0].PARTY_NAME;
    }
    this.setLocalStorage();
  }

  getSelectValues() {
    this.selectValues = JSON.parse(this.rsaService.decrypt(localStorage.getItem('USERACCESS')));
    //console.log('Selecte Values', this.selectValues);
    this.filteredSelection = JSON.parse(this.rsaService.decrypt(localStorage.getItem('USERACCESS')));
    this.uniqueSelectValues = Array.from(new Set(this.filteredSelection.map(x => x.SELLER_BUSINESS_UNIT)));
    this.select1 = localStorage.getItem('select1') ? localStorage.getItem('select1') : 'All';
    this.select2 = localStorage.getItem('select2') ? localStorage.getItem('select2') : 'All';
    this.select3 = localStorage.getItem('select3') ? localStorage.getItem('select3') : 'All';
    this.userName = this.rsaService.decrypt(localStorage.getItem('4'));
    this.partySelected = this.filteredSelection[0].PARTY_ID;
    this.partyNameSelected = this.filteredSelection[0].PARTY_NAME;
    this.getAllPartyList({
      email: this.rsaService.decrypt(localStorage.getItem('3'))
    });
    return true;
  }

  getPartyID() {
    return this.partySelected;
  }

  onFirstSelectChange(value) {
    this.select1 = value;
    if (value !== 'All') {
      this.select1Id = (this.selectValues.find(f => f.SELLER_BUSINESS_UNIT === value)).ORG_ID;
    } else {
      this.select1Id = 'All'
    }

    // this.selectValuesChanged.emit();
    return this.filterValues(1);
  }

  onSecondSelectChange(value) {
    this.select2 = value;
    if (value !== 'All') {
      this.select2Id = (this.selectValues.find(f => f.ACCOUNT_NAME === value)).CUST_ACCOUNT_ID;
    } else {
      this.select2Id = 'All'
    }
    // this.selectValuesChanged.emit();
    return this.filterValues(2);
  }

  onThirdSelectChange(value) {
    this.select3 = value;
    // this.selectValuesChanged.emit();
    if (value !== 'All') {
      this.select3Id = (this.selectValues.find(f => f.CUSTOMER_SITE === value)).CUST_ACCT_SITE_ID;
    } else {
      this.select3Id = 'All'
    }
    return this.filterValues(3);
  }

  filterValues(selected) {

    this.filteredSelection = this.selectValues.filter(val => {
      let a = true;

      if (this.select1 !== 'All') {
        a = a && this.select1 === val.SELLER_BUSINESS_UNIT;
      }

      if (this.select2 !== 'All') {
        a = a && this.select2 === val.ACCOUNT_NAME;
      }

      if (this.select3 !== 'All') {
        a = a && this.select3 === val.CUSTOMER_SITE;
      }

      return a;
    });

    // if (this.filteredSelection.length === 1) {

    //   this.select1 = this.filteredSelection[0].SELLER_BUSINESS_UNIT;
    //   this.select2 = this.filteredSelection[0].ACCOUNT_NAME;
    //   this.select3 = this.filteredSelection[0].CUSTOMER_SITE;
    // } else {
      if (selected === 1) {
        this.select2 = 'All';
        this.select3 = 'All';
      }
      if (selected === 2) {
        this.select3 = 'All';
      }
      if (!selected) {
        console.log('Nothing');
      }
    // }

    this.setLocalStorage();

    this.selectValuesChanged.emit();
    return this.filteredSelection;

  }

  setLocalStorage() {
    localStorage.setItem('select1', this.select1);
    localStorage.setItem('select1Id', this.select1Id);
    localStorage.setItem('select2', this.select2);
    localStorage.setItem('select2Id', this.select2Id);
    localStorage.setItem('select3', this.select3);
    localStorage.setItem('select3Id', this.select3Id);
  }

  getAllPartyList(query) {
    this.http.post(`${this.baseUrl}/partyList`, query).subscribe((data: any) => {
      //console.log('res', data);

      this.partyList = Array.isArray(data.PARTIES.PARTY) ? data.PARTIES.PARTY : (data.PARTIES.PARTY) ? [data.PARTIES.PARTY] : [];
    })
  }

  getPartyDetails(partyID) {
    var query = { email: this.rsaService.decrypt(localStorage.getItem('3')), partyId: partyID }
    this.http.post(`${this.baseUrl}/byPartyId`, query).subscribe((data: any) => {
      console.log('Deatils', data, query);
      let USERACCESS = Array.isArray(data.USERDETAILS.USERACCESSES.USERACCESS) ? data.USERDETAILS.USERACCESSES.USERACCESS : [data.USERDETAILS.USERACCESSES.USERACCESS];
      localStorage.setItem('USERACCESS', this.rsaService.encrypt(JSON.stringify(USERACCESS)));

      this.setSelectValues(USERACCESS, data.USERDETAILS.USER.NO_OF_PARTIES || 0);
      // this.router.navigated = false;
      // this.router.navigate([this.router.url]);


      this.redirectTo(this.router.url)
    })
  }

  redirectTo(uri) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }


  onSelectParty(party_id) {
    this.partySelected = party_id;
    this.partyNameSelected = (this.partyList.find(f => f.PARTY_ID === party_id)).PARTY_NAME;
    this.getPartyDetails(party_id);
  }

  filterListBasedOnCustomer(unfilteredList: Array<any>): Array<any> {
    return unfilteredList.filter(f => {
      let a = true;
      if (this.select1Id && this.select1Id !== 'All') {
        a = a && this.select1Id === f.ORG_ID;
      }
      if (this.select2Id && this.select2Id !== 'All') {
        a = a && this.select2Id === f.CUST_ACCOUNT_ID;
      }
      if (this.select3Id && this.select3Id !== 'All') {
        a = a && this.select3Id === f.CUST_ACCT_SITE_ID;
      }
      return a;
    });
  }


}
